import axios from 'axios';
import { IBitecoinCustomerInfoModel, IBitecoinRewardModel } from 'entities/Bitecoin/Bitecoin.models';

const basePath = '/bitecoin';

export const bitecoinTransport = {
  getBitecoinCustomerInfo: (): Promise<IBitecoinCustomerInfoModel> => {
    return axios.get(`${basePath}/customer-info`);
  },
  getBitecoinRewardCollectionByStoreId: (storeId: string): Promise<IBitecoinRewardModel[]> => {
    return axios.get(`${basePath}/rewards/by-store/${storeId}`);
  },
  getBitecoinRewardCollectionDefault: (): Promise<IBitecoinRewardModel[]> => {
    return axios.get(`${basePath}/rewards/by-store/default`);
  },
};
